// extracted by mini-css-extract-plugin
module.exports = {"header":"PaymentDetailMethodItem_header_3lh3T","detail":"PaymentDetailMethodItem_detail_1-be7","detailItem":"PaymentDetailMethodItem_detailItem_1EKdG"};